export default "__VITE_ASSET__CQR_lD0g__"